import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  AnnouncementsApi,
  AuthApi,
  DogServiceApi,
  UsersApi,
  AppointmentsApi,
  DogsApi,
  TipsApi,
  statsApi,
  stateApi,
  DailyOpsApi,
  SettingsApi,
} from '../services/services';

export const store = configureStore({
  reducer: {
    [AuthApi.reducerPath]: AuthApi.reducer,
    [DogServiceApi.reducerPath]: DogServiceApi.reducer,
    [AnnouncementsApi.reducerPath]: AnnouncementsApi.reducer,
    [UsersApi.reducerPath]: UsersApi.reducer,
    [AppointmentsApi.reducerPath]: AppointmentsApi.reducer,
    [DogsApi.reducerPath]: DogsApi.reducer,
    [TipsApi.reducerPath]: TipsApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    [stateApi.reducerPath]: stateApi.reducer,
    [DailyOpsApi.reducerPath]: DailyOpsApi.reducer,
    [SettingsApi.reducerPath]: SettingsApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      AuthApi.middleware,
      DogServiceApi.middleware,
      AnnouncementsApi.middleware,
      UsersApi.middleware,
      AppointmentsApi.middleware,
      DogsApi.middleware,
      TipsApi.middleware,
      statsApi.middleware,
      stateApi.middleware,
      DailyOpsApi.middleware,
      SettingsApi.middleware
    ),
});

setupListeners(store.dispatch);
